import { render, staticRenderFns } from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=template&id=7c66051e&scoped=true"
import script from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=style&index=0&id=7c66051e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c66051e",
  null
  
)

export default component.exports